<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <div class="banner">
      <img src="../../assets/img/jieju/wb_banner.png" alt class="banner_img" />
      <div class="banner_1">
        <div class="banner_left">
          <img src="../../assets/img/guanyu/sh_logo.png" alt />
          <p>应用类软件定制化开发</p>
          <p style="font-size:18px;color:#FFFFFF;line-height:30px;">一站式软件定制开发服务 全透明项目管控 高保障可靠交付</p>
          <p class="baojia">
            <a href="#">获取报价及方案</a>
          </p>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <div class="content_1">
        <div class="content_one">
          <h1>“互联网+”解决方案</h1>
          <ul class="content_one_ul">
            <li>
              <div class="content_one_ul1">
                <img src="../../assets/img/jieju/wb_icon_case_oa.png" alt />
                <p style="font-size:18px;font-weight:600;margin-bottom:15px;">OA和企业数字化管理</p>
                <p style="font-size:14px;color:#666666;">有效降低管理成本、提升管理效率。无纸化办公系统更安全高效。</p>
              </div>
            </li>
            <li>
              <div class="content_one_ul1">
                <img src="../../assets/img/jieju/wb_icon_case_b2b.png" alt />
                <p style="font-size:18px;font-weight:600;margin-bottom:15px;">B2B管理系统</p>
                <p style="font-size:14px;color:#666666;">打通线上交易平台与线下门店的数据交易，实时掌握业务动态，促进业务快速扩张。</p>
              </div>
            </li>
            <li>
              <div class="content_one_ul1">
                <img src="../../assets/img/jieju/wb_icon_case_crm.png" alt />
                <p style="font-size:18px;font-weight:600;margin-bottom:15px;">CRM管理系统</p>
                <p style="font-size:14px;color:#666666;">通过智能化和社会化的营销工具提升拓客效果和营销产出。</p>
              </div>
            </li>
            <li>
              <div class="content_one_ul1">
                <img src="../../assets/img/jieju/wb_icon_case_erp.png" alt />
                <p style="font-size:18px;font-weight:600;margin-bottom:15px;">ERP管理系统</p>
                <p style="font-size:14px;color:#666666;">有效降低管理成本、提升管理效率。无纸化办公系统更安全高效。</p>
              </div>
            </li>
            <li>
              <div class="content_one_ul1">
                <img src="../../assets/img/jieju/wb_icon_case_app.png" alt />
                <p style="font-size:18px;font-weight:600;margin-bottom:15px;">APP/小程序定制</p>
                <p style="font-size:14px;color:#666666;">围绕企业业务需求，提供符合行业特点的专业产品设计和定制开发服务。</p>
              </div>
            </li>
            <li>
              <div class="content_one_ul1">
                <img src="../../assets/img/jieju/wb_icon_case_web.png" alt />
                <p style="font-size:18px;font-weight:600;margin-bottom:15px;">网站定制</p>
                <p style="font-size:14px;color:#666666;">帮助企业覆盖更多相关用户场景，持续获得流量增长，实现商业价值和整合转换。</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="content_two">
          <h1>一站式定制化开发</h1>
          <img src="../../assets/img/jieju/wb_img_service.png" alt style="margin-bottom:60px;" />
          <ul class="content_two_ul">
            <li>
              <div class="content_two_div">
                <img src="../../assets/img/jieju/wb_icon_service01.png" alt />
                <div class="content_two_p">
                  <p style="font-size:18px;font-weight:600;margin-bottom:10px;">量身打造方案</p>
                  <p style="font-size:14px;color:#666666;">深度了解业务需求，结合真实情况和市场特征，量身打造合理方案</p>
                </div>
              </div>
            </li>
            <li>
              <div class="content_two_div" style="border:0">
                <img src="../../assets/img/jieju/wb_icon_service02.png" alt />
                <div class="content_two_p">
                  <p style="font-size:18px;font-weight:600;margin-bottom:10px;">专业开发团队</p>
                  <p style="font-size:14px;color:#666666;">实战经验丰富，高效、务实、诚信的工作造就了无数优秀作品，团队之间配合默契</p>
                </div>
              </div>
            </li>
            <li>
              <div class="content_two_div">
                <img src="../../assets/img/jieju/wb_icon_service03.png" alt />
                <div class="content_two_p">
                  <p style="font-size:18px;font-weight:600;margin-bottom:10px;">项目按时交付</p>
                  <p style="font-size:14px;color:#666666;">根据产品原型和设计，通过规范开发标准来保障项目质量和工期</p>
                </div>
              </div>
            </li>
            <li>
              <div class="content_two_div" style="border:0">
                <img src="../../assets/img/jieju/wb_icon_service04.png" alt />
                <div class="content_two_p">
                  <p style="font-size:18px;font-weight:600;margin-bottom:10px;">代码质量保证</p>
                  <p style="font-size:14px;color:#666666;">代码规范检查，多方测试验收</p>
                </div>
              </div>
            </li>
            <li>
              <div class="content_two_div">
                <img src="../../assets/img/jieju/wb_icon_service05.png" alt />
                <div class="content_two_p">
                  <p style="font-size:18px;font-weight:600;margin-bottom:10px;">持续运营支持</p>
                  <p style="font-size:14px;color:#666666;">按需提供软件上线后运营支持，修复漏洞服务</p>
                </div>
              </div>
            </li>
            <li>
              <div class="content_two_div" style="border:0">
                <img src="../../assets/img/jieju/wb_icon_service06.png" alt />
                <div class="content_two_p">
                  <p style="font-size:18px;font-weight:600;margin-bottom:10px;">软件灵活迭代</p>
                  <p style="font-size:14px;color:#666666;">源代码交付，软件升级无后顾之忧</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="content4_1">
          <h1>精品案例</h1>
          <div class="content_img">
            <img src="../../assets/img/jieju/case_btn_prev_nor.png" alt />
            <img src="../../assets/img/jieju/case_btn_next_nor.png" alt />
          </div>
          <ul class="content4_ul">
            <li>
              <img src="../../assets/img/jieju/case_bg.png" alt class="posit" />
              <div class="content4_ul_div">
                <img src="../../assets/img/jieju/case_img01.png" alt />
                <p style="font-size:16px;">商企服小程序</p>
                <p>基于商会的一站式企业服务平台。项目现在已经研发完成并上线运营，已获得200万种子轮融资。</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/jieju/case_bg.png" alt class="posit" />
              <div class="content4_ul_div">
                <img src="../../assets/img/jieju/case_img02.png" alt />
                <p style="font-size:16px;">商会后台</p>
                <p>商会免费使用，并获取会员在平台消费的5%服务佣金,帮助商会实现对会员的吸纳管理、内容发布等</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/jieju/case_bg.png" alt class="posit" />
              <div class="content4_ul_div">
                <img src="../../assets/img/jieju/case_img03.png" alt />
                <p style="font-size:16px;">城市站后台</p>
                <p>对地级市或省会城市站进行内容维护，可管理服务商入驻信息及服务类目</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="content_tree">
          <h1>您的想法我们来实现</h1>
          <img src="../../assets/img/jieju/wb_bg_tel.png" alt />
          <div class="content_tree_div">
            <p style="margin-top:65px">立即提交开发需求</p>
            <p style="font-size:18px;color:#666666;margin-bottom:60px;">我们会在24小时内联系您，为您提供项目方案及报价</p>
            <div class="input">
              <el-input placeholder="如何称呼您呢？" height="60px;" class="input1"></el-input>
              <el-input placeholder="请输入您的手机号" class="input1"></el-input>
            </div>
            <div class="dianji">
              <a href="#">获取报价及方案</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: ""
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.banner {
  width: 100%;
  height: 590px;
  position: relative;
}

.banner_img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.banner_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.banner_left {
  width: 500px;
  height: auto;
}

.banner_left img {
  padding: 39px 0;
  margin-bottom: 50px;
}

.banner_left p {
  font-size: 40px;
  color: #fff;
  margin-bottom: 60px;
}

.baojia {
  width: 275px;
  height: 60px;
  background: linear-gradient(
    90deg,
    rgba(255, 215, 155, 1),
    rgba(255, 184, 112, 1)
  );
  border-radius: 30px;
  line-height: 0px;
  text-align: center;
}

.baojia a {
  font-size: 24px;
  line-height: 60px;
  color: #65473b;
}

.content {
  width: 100%;
  height: auto;
}

.content_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content_one h1 {
  text-align: center;
  margin: 146px 0 64px 0;
}

.content_one_ul li {
  width: 380px;
  height: 222px;
  background: #fff;
  border: 1px solid rgba(230, 232, 237, 1);
  box-shadow: 0px 2px 20px 0px rgba(237, 237, 237, 1);
  border-radius: 4px;
  float: left;
  margin-bottom: 25px;
}

.content_one_ul li:nth-child(2) {
  margin: 0 25px;
}
.content_one_ul li:nth-child(5) {
  margin: 0 25px;
}

.content_one_ul1 {
  width: 308px;
  height: auto;
  margin: 18px auto;
  text-align: center;
}

.content_one_ul1 img {
  width: 72px;
  height: 72px;
  margin-bottom: 15px;
}

.content_one_ul1 p {
  line-height: 25px;
}

.content_two {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.content_two h1 {
  text-align: center;
  margin: 113px 0 64px 0;
}

.content_two_ul {
  width: 100%;
  height: auto;
}

.content_two_ul li {
  width: 600px;
  height: 130px;
  float: left;
}

.content_two_ul li:nth-child(1),
.content_two_ul li:nth-child(2),
.content_two_ul li:nth-child(3),
.content_two_ul li:nth-child(4) {
  border-bottom: 1px solid #e4e4e4;
}

.content_two_div {
  width: 550px;
  height: 98px;
  border-right: 1px solid #e4e4e4;
  float: right;
  margin-top: 15px;
}

.content_two_div img {
  float: left;
  padding: 15px 0;
}

.content_two_p {
  width: 308px;
  float: left;
  margin-top: 15px;
  margin-left: 50px;
}

.content4_1 {
  width: 1200px;
  height: 600px;
  margin: 0 auto;
}

.content4_1 h1 {
  text-align: center;
  margin: 96px 0 4px 0;
}

.content_img {
  float: right;
  margin-bottom: 30px;
}

.content4_ul {
  width: 100%;
  overflow: hidden;
}

.content4_ul li {
  width: 386px;
  height: 408px;
  position: relative;
  float: left;
  margin: 0 0 0 20px;
}

.content4_ul li:first-child {
  margin: 0;
}

.posit {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content4_ul_div {
  width: 364px;
  height: auto;
  margin: 10px auto;
}

.content4_ul_div img {
  margin-bottom: 30px;
}

.content4_ul_div p {
  color: #fff;
  font-size: 14px;
  line-height: 25px;
}

.content_tree {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  margin-bottom: 144px;
}

.content_tree h1 {
  text-align: center;
  margin: 70px 0 60px 0;
}

.content_tree img {
  position: absolute;
  top: -0%;
  right: 0;
}

.content_tree_div {
  width: 1200;
  height: 488px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(230, 232, 237, 1);
  box-shadow: 0px 2px 20px 0px rgba(237, 237, 237, 1);
  border-radius: 4px;
}

.content_tree_div p {
  font-size: 28px;
  text-align: center;
  line-height: 50px;
}

.input {
  width: 400px;
  height: auto;
  margin: 0 auto;
}

.input1 {
  width: 100%;
  height: 60px;
  border-radius: 25px;
}

.dianji {
  width: 400px;
  height: 40px;
  background: linear-gradient(
    90deg,
    rgba(0, 123, 255, 1),
    rgba(115, 76, 231, 1)
  );
  border-radius: 30px;
  margin: 0 auto;
  text-align: center;
  line-height: 40px;
}

.dianji a {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/Jiejue/Waibao.vue